import { FormInstance, Row } from "antd";
import { ReactNode, useMemo } from "react";
import { useCalculateInterestPerDiem } from "../../../hooks/calculateInterestPerDiem";
import { FloatNumberInput } from "../../../../../../../../../components/FloatNumberInput";

type BalanceProps = {
  form: FormInstance;
  isDisabled: boolean;
};

export const Balance = ({ form, isDisabled }: BalanceProps) => {
  const { calculate } = useCalculateInterestPerDiem(form);

  const formItems: ReactNode = useMemo(() => {
    const values: any = [
      {
        name: "balancePrincipal",
        label: "Principal",
        disabled: isDisabled,
      },
      {
        name: "balanceUnpaidInterest",
        label: "Unpaid Interest",
        disabled: isDisabled,
      },
      {
        name: "balanceUnpaidLateCharges",
        label: "Unpaid Late Charges",
        disabled: isDisabled,
      },
      {
        name: "balancePartialPayments",
        label: "Partial Payment",
      },
      {
        name: "balanceImpound",
        label: "Impound",
        disabled: true,
      },
    ];

    return values.map((item: any, i: number) => (
      <Row className="align-center mb-4 justify-space-between" key={i}>
        <span className="text-md title">{item.label}</span>
        <FloatNumberInput
          name={item.name}
          label=""
          form={form}
          className="mb-0 balance__form-item"
          disabled={item.disabled}
          onChange={() => item.name === "balancePrincipal" && calculate()}
          includeThousandsSeparator
        />
      </Row>
    ));
  }, [calculate, form, isDisabled]);

  return (
    <>
      <h5 className="mt-4 mb-5 h h5 card-header">Balance</h5>
      {formItems}
    </>
  );
};
